// import { capitalize } from 'lodash';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import { RangeInput } from 'shared/components/FormControl';
import { FONT_SIZES, SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import ButtonStylePicker from 'dashboard/components/FormControls/ButtonStylePicker';
// import SelectField, { Option } from 'dashboard/components/FormControls/SelectField';
import ThemeEditorFormActionFooter, {
  ACTION_FOOTER_HEIGHT,
} from 'dashboard/components/ThemeEditorFormActionFooter';
import { FORM_THEME_EDITOR_BUTTONS_NAME } from 'dashboard/lib/constants/formNames';
import { COLORS } from 'dashboard/styles/variables';
// import { TextTransform } from 'lib/interfaces/ThemeSerialized';

const Title = styled('h2')`
  color: ${COLORS.black};

  padding-top: ${SPACINGS.base * 5}px;
  padding-left: ${SPACINGS.base * 2}px;
  padding-bottom: ${SPACINGS.base * 3}px;
  border-bottom: 1px solid ${COLORS.gray20};
`;
const Section = styled('div')`
  padding: ${SPACINGS.base * 2}px;
  margin-bottom: ${ACTION_FOOTER_HEIGHT};
`;
const StyledLabel = styled('label')`
  display: inline-block;
`;
const Hint = styled('p')`
  font-size: ${FONT_SIZES.small};
  color: ${COLORS.gray50};
  margin-bottom: ${SPACINGS.base}px;
`;
const StyledField = styled(Field)<any>`
  margin-bottom: ${SPACINGS.base * 3}px;
`;

interface FormThemeEditorButtonsProps {
  disabled?: boolean;
}

const FormThemeEditorButtons = (props: FormThemeEditorButtonsProps & InjectedFormProps) => {
  return (
    <form onSubmit={props.handleSubmit}>
      <Title>Buttons</Title>
      <Section>
        <StyledLabel htmlFor='button-theme-form__border-radius-input'>
          Button border radius
        </StyledLabel>
        <Hint>Border radius for button shape</Hint>
        <StyledField
          id='button-theme-form__border-radius-input'
          name='theme.border-radius'
          component={RangeInput}
          min={0}
          max={30}
          unit='px'
          format={(value: string) => (value ? value.substr(0, value.length - 2) : '')}
          normalize={(value: number) => `${value}px`}
        />

        <StyledLabel>Button style</StyledLabel>
        <Hint>Box shadow for button style</Hint>
        <StyledField name='theme.button-shadow-strength' component={ButtonStylePicker} />

        <StyledLabel htmlFor='button-theme-form__border-width-input'>
          Secondary button border width
        </StyledLabel>
        <Hint>Border width for secondary button actions</Hint>
        <StyledField
          id='button-theme-form__border-width-input'
          name='theme.border-width'
          component={RangeInput}
          min={0}
          max={4}
          unit='px'
          format={(value: string) => (value ? value.substr(0, value.length - 2) : '')}
          normalize={(value: number) => `${value}px`}
        />
        {/* Hiding the following component temporarily as Theme set has no corresponding support */}
        {/* Will re-enable once serve side theming for attribute is implmented */}
        {/* <StyledLabel htmlFor='button-theme-form__text-transform-select'>
          Button text transform
        </StyledLabel> */}
        {/* <StyledField
          id='button-theme-form__text-transform-select'
          name='theme.button-text-transform'
          component={SelectField}
        > */}
        {/* {Object.keys(TextTransform).map((textTransformKey: keyof typeof TextTransform) => (
            <Option key={textTransformKey} value={TextTransform[textTransformKey]}>
              {capitalize(TextTransform[textTransformKey])}
            </Option>
          ))} */}
        {/* </StyledField> */}
      </Section>
      {!props.disabled && (
        <ThemeEditorFormActionFooter
          dataTestBlock='form-theme-editor-buttons'
          handleUndo={props.reset}
          submitting={props.submitting}
          pristine={props.pristine}
        />
      )}
    </form>
  );
};

export default reduxForm<{}, FormThemeEditorButtonsProps>({
  form: FORM_THEME_EDITOR_BUTTONS_NAME,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(FormThemeEditorButtons);
